import { StyledCard } from "./styled";
import { ICardProps } from "./types";

const Card = ({children, variant, backgroundColor = 'black', ...props}: ICardProps) => (
    <StyledCard {...props} customBgColor={backgroundColor}>
        {children}
    </StyledCard>
)

export {Card}